/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PriceDisplay_sku$ref = any;
export type PriceDisplay_sku = {
    readonly serviceId?: string | null;
    readonly pricing?: {
        readonly percentageOff: {
            readonly salePrice: string | null;
            readonly netPrice: string | null;
        } | null;
        readonly saleOriginPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly retailPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly salePrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly netPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
    } | null;
    readonly displayInfo?: {
        readonly pricing: {
            readonly quantityDisplay: string | null;
            readonly showSold: boolean | null;
            readonly showUnavailable: boolean | null;
            readonly showPUR: boolean | null;
            readonly showNet: boolean | null;
            readonly showSale: boolean | null;
            readonly showRetail: boolean | null;
            readonly showOriginal: boolean | null;
            readonly showOnHold: boolean | null;
            readonly showOnHoldCustom: boolean | null;
            readonly showListPriceLabel: boolean | null;
        } | null;
    } | null;
    readonly " $refType": PriceDisplay_sku$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "convertedAmountList",
            "storageKey": null,
            "args": null,
            "concreteType": "ConvertedAmountList",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "currency",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "amount",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "PriceDisplay_sku",
        "type": "ItemSkuType",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "hasSkuId",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "hasUserId",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "userId",
                "type": "String!",
                "defaultValue": ""
            },
            {
                "kind": "LocalArgument",
                "name": "page",
                "type": "PageDisplayEnum",
                "defaultValue": "pdp"
            }
        ],
        "selections": [
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasSkuId",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "serviceId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pricing",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPricing",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "percentageOff",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PercentageOff",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "salePrice",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "netPrice",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "saleOriginPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "retailPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "salePrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "netPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "buyerId",
                                "variableName": "userId"
                            },
                            {
                                "kind": "Variable",
                                "name": "page",
                                "variableName": "page"
                            }
                        ],
                        "concreteType": "SkuDisplayInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pricing",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PriceInfoDisplay",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "quantityDisplay",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSold",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showUnavailable",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showPUR",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showNet",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSale",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showRetail",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showOriginal",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showOnHold",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showOnHoldCustom",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showListPriceLabel",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'ff715abba2ba2bdc805f6e72e3f5ea28';
export default node;
